import React from "react";
import {
	UserInfoResponse
} from "services/utils/interfaces";
import "./InfoSection.less";
import { Tag, Collapse } from "antd";
import useWindowDimensions from "../../../../common/functions";
import i18n from "i18next";

type Props = {
	data: any,
	shouldRefresh: boolean,
	chargerId: string,
	status: string
};

const { Panel } = Collapse;

const InfoSection:React.FC<Props> = ({
	data,
	status
}):React.ReactElement => {
	const getStatus = () => {
		let color = "#CECECE";
		if (status === "Expired") {
			color = "#FF7866";
		} else if (status === "Active") {
			color = "#9DCC78";
		} else if (status === "Inactive") {
			color = "#FED077";
		} else if (status === "In use") {
			color = "#E088FF";
		}
		return <Tag className="tag" color={color} key={status}>{status.toUpperCase()}
			</Tag>;
	};

	const {width} = useWindowDimensions();
	const dataUpdated = {};
	Object.keys(data).forEach(key => {
		if (key === "active") {
			if(data[key]) {
				dataUpdated[i18n.t("users.active")] = "True"
			}else{
				dataUpdated[i18n.t("users.active")] = "False"
			}
		} else if (key === "email") {
			dataUpdated[i18n.t("users.email")] = data[key];
		} else if (key === "chargerId") {
			dataUpdated[i18n.t("users.chargerId")] = data[key].toUpperCase();
		} else if (key === "stationName") {
			dataUpdated[i18n.t("users.station")] = data[key];
		} else if (key === "name") {
			dataUpdated[i18n.t("users.name")] = data[key];
		} else if (key === "userId") {
			dataUpdated[i18n.t("users.userId")] = data[key];
		}else if (key === "priorityType") {
			dataUpdated[i18n.t("users.priorityType")] = data[key];
		}
	});

	const order = [
		i18n.t("users.station"),
		i18n.t("users.chargerId"),
		i18n.t("users.userId"),
		i18n.t("users.name"),
		i18n.t("users.email"),
		i18n.t("users.priorityType"),
		i18n.t("users.active")
		
	];

	const sortedKeys = order.filter(key => Object.keys(dataUpdated).includes(key));

	return (
        <>
            {width > 768 && data ? (
                <div style={{ background: '#fff' }}>
                    <section className="charger-info-header">
					<div className="charger-Id"></div>
                    </section>
                    <section className="get-charger-info-content">
                        {sortedKeys.map(key => (
                            <section key={key} className="info-card">
                                <div className="key">{key}</div>
                                <div className="property">{dataUpdated[key]}</div>
                            </section>
                        ))}
                    </section>
                </div>
            ) : (
                data && (
                    <>
                        <section className="charger-info-header-mobile">
						<div className="charger-Id-mobile"></div>
                        </section>
                        <Collapse defaultActiveKey={["1"]} className="info-collapse">
                            {sortedKeys.map(key => (
                                <Panel header={key} key={key}>
                                    <p>{dataUpdated[key]}</p>
                                </Panel>
                            ))}
                        </Collapse>
                    </>
                )
            )}
        </>
    );
};


export default InfoSection;
